import styled from "styled-components";

export const MultiSelectDropdownWrapper = styled.div`
    position: relative;
    width: 100%;

    input {
        cursor: default;
        caret-color: transparent;
        text-transform: capitalize;
        padding-right: 26px;
    }

    svg.chevron-icon {
        width: 16px;
        height: 16px;
        color: var(--text-color-secondary);
        position: absolute;
        top: 0;
        bottom: 0;
        right: 12px;
        margin: auto;
        transform: rotate(90deg);
        transition: all ease-in-out 0.3s;

        &.chevron-rotate {
            transform: rotate(-90deg);
        }
    }
`;

export const MultiDropdownOptions = styled.div`
    position: absolute;
    top: 120%;
    right: 0;
    z-index: 8;
    min-width: 100%;
    max-height: 40vh;

    background-color: var(--theme-color-secondary);
    border: 1px solid var(--border-color);
    padding: 5px 0;
    border-radius: 10px;
    overflow: auto;

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        font-size: 14px;

        > *:not(:last-child) {
            border-bottom: 1px solid var(--table-border-color);
        }

        li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: transparent;
            color: var(--text-color-secondary);
            text-transform: capitalize;
            /* white-space: nowrap; */
            padding: 10px 20px;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            /* white-space: nowrap; */
            gap: 4px;
            transition: all ease-in-out 0.3s;

            svg {
                width: 16px;
                height: auto;
                flex-shrink: 0;
            }

            &:hover {
                background-color: var(--table-border-color);
            }

            &.active {
                background-color: var(--theme-color-primary);
                color: var(--theme-color-white);
            }
        }
    }
`;